import type { ActiveChat, ChatContact, ChatContactWithChat } from '../../types'
import type { ChatListTab } from '../../constants/chat'
import type { useRateLimit } from '../../composables/useRateLimit'

export interface ChatViewState {
  chatsContacts: ChatContactWithChat[]
  contacts: ChatContact[]
  profileUser: ChatContact | undefined
  activeChat: ActiveChat
  chatListTab: ChatListTab
  isLoading: boolean
  isLoadingChat: boolean
  isScrollingToBottom: boolean
  messageRateLimiter: ReturnType<typeof useRateLimit> | null
  fileMessageRateLimiter: ReturnType<typeof useRateLimit> | null
  lastMessageReaders: any[] | null
}

export interface ChatViewThis extends ChatViewState {
  $state: ChatViewState
  [key: string]: any
}

export function defineChatViewActions<A>(actions: A & ThisType<ChatViewThis>): A {
  return actions
}
